import { Rocket } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Мастер подключения клиники (4.1, шаг 2; ПОРТ-10, ПОРТ-11, ПОРТ-30, ПОРТ-43). Только собственник; в навигации — через чек-лист. */
export const section = defineSection({
  id: 'org.onboarding',
  area: 'clinic',
  path: 'onboarding',
  roles: ['OWNER'],
  icon: Rocket,
  titleKey: 'onboarding:title',
  namespaces: ['portal', 'branches', 'billing', 'clinicSettings'],
  navGroup: 'work',
  order: 5,
  nav: false,
  load: () => import('./OnboardingPage'),
});
